import { message } from "antd";
import { MedicalCondition } from "../types/codeIdentifier";

export const useCopyUtilities = (finalEvaluation: MedicalCondition[]) => {
  // Copy to clipboard function
  const copyToClipboard = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(`${label} copied to clipboard!`);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      message.success(`${label} copied to clipboard!`);
    }
  };

  // Helper function to get all codes from a condition (handles both single and multiple codes)
  const getCodesFromCondition = (condition: MedicalCondition) => {
    if (condition.best_icd10_codes && condition.best_icd10_codes.length > 0) {
      return condition.best_icd10_codes;
    }
    // Fallback for backward compatibility
    if ((condition as any).best_icd10_code) {
      return [(condition as any).best_icd10_code];
    }
    return [];
  };

  // Get all valid codes for copying (deduplicated)
  const getAllValidCodes = () => {
    const codes: string[] = [];
    
    finalEvaluation.forEach(item => {
      const itemCodes = getCodesFromCondition(item);
      itemCodes.forEach(code => {
        if (code.code && code.code !== "N/A" && code.code !== "No Code" && code.code !== "NO_CODE" && code.code !== "UNKNOWN") {
          codes.push(code.code);
        }
      });
    });
    
    // Remove duplicates and sort for consistent ordering
    const uniqueCodes = [...new Set(codes)].sort();
    return uniqueCodes.join(', ');
  };

  // Get count of unique valid codes
  const getUniqueValidCodesCount = () => {
    const codes: string[] = [];
    
    finalEvaluation.forEach(item => {
      const itemCodes = getCodesFromCondition(item);
      itemCodes.forEach(code => {
        if (code.code && code.code !== "N/A" && code.code !== "No Code" && code.code !== "NO_CODE" && code.code !== "UNKNOWN") {
          codes.push(code.code);
        }
      });
    });
    
    return new Set(codes).size;
  };

  // Copy all unique codes function
  const copyAllCodes = () => {
    const allCodes = getAllValidCodes();
    if (allCodes) {
      copyToClipboard(allCodes, 'All codes');
    } else {
      message.warning('No valid codes found to copy');
    }
  };

  return {
    copyToClipboard,
    getAllValidCodes,
    getUniqueValidCodesCount,
    copyAllCodes
  };
}; 